<template>
  <div
    style="text-align: -webkit-center"
    v-show="token && user.followingNo !== 0"
  >
    <v-row class="mt-3 mr-3">
      <div v-for="(story, index) in stories" :key="index">
        <div @click="storyclick(story)" style="cursor: pointer">
          <picture>
            <source type="image/webp" :srcset="story.image" />
            <v-avatar @click="over = !over" class="gradient" size="56">
              <img :src="story.image" />
            </v-avatar>
          </picture>
          <v-card-title>{{ story.name }}</v-card-title>
        </div>
        <v-overlay :value="over">
          <div style="align-items: flex-start; justify-content: flex-start">
            <v-btn class="pa-1" icon @click="over = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <vue-social-media-stories
            :width="400"
            :height="550"
            :stories="stories2"
            :loop="false"
            :isPause="true"
            :fullscreenMode="false"
            v-on:lastframe="LastFrame($event)"
          />
        </v-overlay>
      </div>
    </v-row>
    <v-divider></v-divider>
    <v-col
      align="center"
      v-for="(item, index) in posts"
      :key="index"
      cols="12"
      md="5"
      sm="12"
      class="rounded-lg"
    >
      <v-sheet
        v-for="(item, index) in posts"
        :key="'sceleton' + index"
        :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
        class="pa-2"
        v-show="firstLoad"
      >
        <v-skeleton-loader
          type="table-heading,divider,image, article"
        ></v-skeleton-loader>
      </v-sheet>
      <v-card class="pa-1" align="center" v-if="token" v-show="!firstLoad">
        <v-card-title>
          <v-row>
            <picture>
              <source type="image/webp" :srcset="item.business.image" />
              <v-avatar size="56">
                <img :src="item.business.image" />
              </v-avatar>
            </picture>
            <v-card-title>{{ item.business.name }}</v-card-title>
            <!-- <v-card-text>{{ item.created_at }}</v-card-text> -->
          </v-row>
        </v-card-title>
        <div class="pa-3">
          <v-carousel
            class="rounded-lg height"
            hide-delimiter-background
            delimiter-icon="mdi-minus"
            show-arrows-on-hover
            height="400"
          >
            <v-carousel-item
              class="rounded-lg"
              v-for="(items, index) in item.slides"
              :key="index"
              :src="items.media"
              :alt="item.caption"
              :aspect-ratio="16 / 9"
              reverse-transition="fade-transition"
              transition="fade-transition"
            />
          </v-carousel>
          <v-row class="ma-2">
            <v-btn
              @click="[item.isLike == false ? like(item) : dislike(item)]"
              small
              :color="item.isLike == true ? 'red' : 'grey'"
              icon
            >
              <v-icon
                large
                v-text="item.isLike == true ? 'mdi-heart' : 'mdi-heart-outline'"
              ></v-icon>
            </v-btn>
            <span class="mx-1" style="align-self: center"
              >{{ item.likes }} لایک</span
            >
            <v-btn icon class="mx-1">
              <v-icon large>mdi-comment-outline</v-icon>
            </v-btn>
            <span class="mx-1" style="align-self: center"
              >{{ item.comments }} نظر</span
            >
            <v-spacer></v-spacer>
            <v-btn @click="bookmark(item)" small icon>
              <v-icon
                v-show="item.isBookmark == true"
                large
                v-text="'mdi-bookmark'"
              ></v-icon>
              <v-icon
                large
                v-show="item.isBookmark == false"
                v-text="'mdi-bookmark-outline'"
              ></v-icon>
            </v-btn>
          </v-row>
        </div>
        <v-card-text style="text-align: start; font-weight: 900">
          <span style="font-weight: 500">{{ item.business.name }}</span>
          {{ item.caption }}
        </v-card-text>
      </v-card>
    </v-col>
    <div v-if="posts.length" v-observe-visibility="handleScrolledBottom"></div>
  </div>
</template>

<script>
import VueSocialMediaStories from "vue-social-media-stories/src/vue-social-media-stories.vue";

export default {
  metaInfo: {
    // title will be injected into parent titleTemplate
    title: "نامیا | خانه",
  },
  components: {
    VueSocialMediaStories,
  },
  inject: {
    theme: {
      default: { isDark: false },
    },
  },
  data() {
    return {
      current_page: 1,
      last_page: 1,
      posts: [],
      stories: [],
      token: null,
      // like: false,
      firstLoad: true,
      overlay: false,
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      over: false,
      stories2: [],
      user: [],
    };
  },
  watch: {
    overlay(val) {
      val &&
        setTimeout(() => {
          this.overlay = false;
        }, 3000);
    },
  },
  methods: {
    async post() {
      var self = this;
      let response = await self.axios.get(
        "https://namya.ir/api/v1/home/posts?page=" + this.current_page,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.token}`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      );
      self.posts.push(...response.data.data);
      this.last_page = response.data.last_page;
    },
    async story() {
      var self = this;
      let response = await self.axios.get(
        "https://namya.ir/api/v1/home/stories",
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.token}`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      );
      self.stories = response.data.data;
      // this.stories2.url = this.stories[0].stories[0].image;
    },
    storyclick(item) {
      for (let i = 0; i < item.stories.length; i++) {
        this.stories2[i] = {
          url: item.stories[i].image,
          duration: 3500,
          type: "image",
        };
      }
      console.warn("hel", this.stories2);
    },
    LastFrame(value) {
      console.warn(value);
      this.over = false;
      this.stories2 = [];
    },
    async like(item) {
      var self = this;
      let response = await self.axios.get(
        "https://namya.ir/api/v1/businesses/post/like/" + item.id,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.token}`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      );
      item.isLike = response.data.success;
      // self.stories = response.data.data;
    },
    async dislike(item) {
      var self = this;
      let response = await self.axios.get(
        "https://namya.ir/api/v1/businesses/post/dislike/" + item.id,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.token}`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      );
      item.isLike = response.data.success == true ? (item.isLike = false) : "";
      // self.stories = response.data.data;
    },
    async bookmark(item) {
      var self = this;
      let response = await self.axios.post(
        "https://namya.ir/api/v1/businesses/post/bookmark/" + item.id,
        "",
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.token}`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      );
      if (response.data.success.indexOf("اضافه") > -1) {
        item.isBookmark = true;
      } else if (response.data.success.indexOf("حذف") > -1) {
        item.isBookmark = false;
      }
      // self.stories = response.data.data;
    },
    handleScrolledBottom(isVisible) {
      if (!isVisible) {
        return;
      }
      if (this.current_page >= this.last_page) {
        return;
      }
      if (this.current_page < 4) {
        this.current_page++;
        this.overlay = !this.overlay;
        this.post();
      }
    },
    async GetUser() {
      var self = this;
      let response = await self.axios.get("https://namya.ir/api/v1/users", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.token}`,
          "Access-Control-Allow-Origin": "*",
        },
      });
      self.user = response.data.data;
    },
  },
  created() {
    this.GetUser();
    this.story();
    this.post();
  },
  mounted() {
    this.token = localStorage.token;
    setTimeout(() => (this.firstLoad = false), 4000);
  },
};
</script>

<style>
@media (max-width: 900px) {
  .height {
    height: 350px !important;
  }
}
.gradient {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(to right, red, orange);
  padding: 30px !important;
}
</style>
